import { Component, OnInit } from '@angular/core';
import { GlobalesService } from 'src/app/servicios/globales.service';

import { ThemeService } from '../../../../theme/theme.service';

@Component({
  selector: 'app-pregunta-urna-electronica',
  templateUrl: './pregunta-urna-electronica.component.html',
  styleUrls: ['./pregunta-urna-electronica.component.scss']
})
export class PreguntaUrnaElectronicaComponent implements OnInit {

  Search = "";
  constructor(public _globalService: GlobalesService,public themeService: ThemeService,) { }

  ngOnInit(): void {
    this._globalService.searchItem.subscribe(data =>{
      if(data == null) return;
      this.Search = data
    });
  }

}
